// src/layouts/ToolLayout/index.tsx
import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { usePullToRefresh } from "src/hooks/usePullToRefresh/usePullToRefresh";
import { PullToRefreshIndicator } from "src/components/common/PullToRefreshIndicator/PullToRefreshIndicator";

interface ToolLayoutProps {
  children?: ReactNode;
}

// Halaman tool merender Navbar/Footer sendiri dan memakai window.scrollTo,
// jadi container ini tidak boleh menjadi elemen scroll.
const ToolLayout: FC<ToolLayoutProps> = ({ children }) => {
  const isMobile = localStorage.getItem("isMobile");
  const shouldEnablePTR = !(isMobile == "false" || isMobile == null);

  const handleRefresh = async () => {
    window.location.reload();
  };

  const { containerRef, isRefreshing, pullDistance, threshold } =
    usePullToRefresh({
      onRefresh: handleRefresh,
      disabled: !shouldEnablePTR
    });

  return (
    <Box ref={shouldEnablePTR ? containerRef : null}>
      {shouldEnablePTR && (
        <PullToRefreshIndicator
          isRefreshing={isRefreshing}
          pullDistance={pullDistance}
          threshold={threshold}
        />
      )}
      {children || <Outlet />}
    </Box>
  );
};

ToolLayout.propTypes = {
  children: PropTypes.node,
};

export default ToolLayout;
